import { render } from "./beneficiary_periodView.vue?vue&type=template&id=c274ad4c"
import script from "./beneficiary_periodView.vue?vue&type=script&lang=js"
export * from "./beneficiary_periodView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__